
import { BoundingSphere, Cartesian3, Cartographic, Cesium3DTileStyle, clone, Math as MathCesium, Viewer } from 'cesium';
import { InputIsolate, InputSetColor } from 'src/class/styleElement';
import { FeatureObject, InputObjTask, ObjDataPrimitiveModel, ObjectConnect, TaskColorByObj } from '../interfaces/styleElement.interface';
import { convertHexWithOpacity, rgbaToHex } from '../utils/utils';
import { ContextMenu } from './contextMenu';


export class InputDataPrimitive {
    ObjDataPrimitive: ObjDataPrimitiveModel[] = []
    listPrimitive: any[] = []
    listKeyMapObject: Record<string, Partial<ObjectConnect>> | undefined = undefined;
    private _viewer: Viewer
    private _contextMenu: ContextMenu | undefined

    constructor(viewer: Viewer) {
        this._viewer = viewer
    }
    setContextMenu = (contextMenu: ContextMenu) => {
        this._contextMenu = contextMenu

    }
    //#region setInputObjDataPrimitive
    setInputObjDataPrimitive = async (urlConnect: string, urlTile: string) => {
        if (!urlConnect) {
            return;
        }

        let data: ObjectConnect;
        try {
            // Thử fetch dữ liệu từ URL
            const response = await fetch(urlConnect);
            if (response.ok) {
                const tempData = await response.json();
                // Kiểm tra xem có key nào viết hoa hay không
                if (Object.keys(tempData).some(key => key[0] === key[0].toUpperCase())) {
                    // Nếu có ít nhất một key viết hoa
                    data = {
                        folder: tempData.Folder,
                        objectConnects: tempData.ObjectConnects
                    }

                } else {
                    // Nếu tất cả các key đều viết thường
                    data = tempData
                }
                // console.log("data",data);
            } else {
                // Xử lý trường hợp HTTP lỗi (ví dụ: 404)
                console.warn(`Không tìm thấy tài nguyên: ${urlConnect} (HTTP ${response.status})`);
                data = {}; // Đặt dữ liệu là undefined nếu không fetch được
            }
        } catch (error) {
            // Bắt lỗi nếu fetch thất bại (ví dụ: lỗi mạng)
            console.warn(`Lỗi khi truy cập URL: ${urlConnect}`);
            return undefined;
        }

        // Duyệt qua ObjDataPrimitive để tìm primitive có url === path
        let existingObjData = this.ObjDataPrimitive.find((obj) => obj.primitive.resource && obj.primitive.resource.url === urlTile);

        // Kiểm tra nếu tìm thấy primitive tương ứng
        if (existingObjData) {


            // Cập nhật lại data mới, giữ lại originalBoundingBox và các giá trị khác từ existingObjData
            existingObjData.data = {
                ...existingObjData.data,   // Giữ lại dữ liệu cũ
                ...data                    // Gán giá trị mới
            };

            // Chỉ cập nhật originalBoundingBox nếu nó chưa có giá trị (undefined)
            if (!existingObjData.data.originalBoundingBox) {
                existingObjData.data.originalBoundingBox = clone(existingObjData.primitive.boundingSphere?.center);
            }


            // Sử dụng map và reduce để chuyển đổi dữ liệu
            const listMapKey = (existingObjData.data.objectConnects ?? []).reduce((acc: Record<string, Partial<ObjectConnect>>, curr) => {
                if (!curr) return acc;
                // Lấy guid làm key và các thuộc tính còn lại là giá trị
                const { guid, ...rest } = curr;
                if (guid) {
                    if (!acc[guid]) {
                        acc[guid] = {
                            folder: data.folder,
                            objectConnects: [],
                            originalBoundingBox: existingObjData.data?.originalBoundingBox || undefined,
                            primitive: existingObjData?.primitive
                        };
                    }

                    acc[guid].objectConnects!.push({ guid, ...rest }); // đảm bảo đúng kiểu FeatureObject
                }

                return acc;
            }, {} as Record<string, Partial<ObjectConnect>>);
            // Kiểm tra nếu `this.listKeyMapObject` đã được khởi tạo
            if (!this.listKeyMapObject) {
                this.listKeyMapObject = {};
            }

            this.listKeyMapObject = {
                ...this.listKeyMapObject,
                ...listMapKey,
            };




            return existingObjData; // Trả về đối tượng đã cập nhật
        } else {
            // Nếu không tìm thấy, trả về undefined
            return undefined;
        }
    };


    //#region  setObjDataPrimitive

    setObjDataPrimitive = async (urlPrimitive: string) => {
        if (!urlPrimitive) {
            return
        }

        let primitive;

        // Duyệt qua các primitives để tìm primitive phù hợp
        for (let i = 0; i < this._viewer.scene.primitives.length; ++i) {
            const pri = (this._viewer.scene.primitives as any)["_primitives"][i];
            if (pri.resource && pri.resource.url && pri.resource.url === urlPrimitive) {
                primitive = pri;
                break;
            }
        }

        // Kiểm tra nếu không tìm thấy primitive
        if (!primitive) {
            return undefined; // Nếu không có primitive, trả về undefined
        }
        // Kiểm tra nếu primitive đã có trong ObjDataPrimitive theo url
        const existingObjData = this.ObjDataPrimitive.find(item => item.primitive.resource?.url === urlPrimitive);

        if (existingObjData) {

            // Nếu đã có, gán lại primitive
            existingObjData.primitive = primitive;

            if ((existingObjData.conditionColors ?? []).length > 0) {

                existingObjData.primitive.colorBlendMode = 1
                if (this._contextMenu?.tempCondition?.conditionColor) {

                }
                // Sử dụng sort để di chuyển phần tử có "true" về cuối
                existingObjData.conditionColors?.sort((a, b) => {
                    if (a[0] === "true") return 1; // Đưa a về cuối nếu a là "true"
                    if (b[0] === "true") return -1; // Đưa b về cuối nếu b là "true"
                    return 0; // Giữ nguyên vị trí nếu không có "true"
                });

                existingObjData.primitive.style = new Cesium3DTileStyle({
                    defines: {
                        batchId: "${feature['BatchId']}",
                        fileName: "${feature['Filename']}",
                        guid: "${feature['Guid']}"
                    },
                    color: {
                        conditions: existingObjData.conditionColors,
                    },
                });
            }

            if ((existingObjData.conditionIsolates ?? []).length > 0) {
                existingObjData.primitive.colorBlendMode = 1
                // Sử dụng sort để di chuyển phần tử có "true" về cuối
                existingObjData.conditionIsolates?.sort((a, b) => {
                    if (a[0] === "true") return 1; // Đưa a về cuối nếu a là "true"
                    if (b[0] === "true") return -1; // Đưa b về cuối nếu b là "true"
                    return 0; // Giữ nguyên vị trí nếu không có "true"
                });
                existingObjData.primitive.style = new Cesium3DTileStyle({
                    defines: {
                        batchId: "${feature['BatchId']}",
                        fileName: "${feature['Filename']}",
                        guid: "${feature['Guid']}"
                    },
                    color: {
                        conditions: existingObjData.conditionIsolates,
                    },
                });
            }
            if (this._contextMenu) {
                if (this._contextMenu.listPicked.length > 0) {
                    this._contextMenu.listPicked = []
                }
                if (this._contextMenu.tempCondition?.conditionColor) {
                    this._contextMenu.conditionsIsolate = this._contextMenu.tempCondition.conditionColor || []
                    this._contextMenu.listPicked = this._contextMenu.tempCondition?.listPicked || []
                    this._contextMenu.isLoadFromShow = true
                    this._contextMenu?.contextMenu_Isolate()
                    this._contextMenu.isLoadFromShow = false

                }
                if (this._contextMenu.tempCondition?.conditionShow) {
                    this._contextMenu.conditionForShowOff = this._contextMenu.tempCondition.conditionColor || []
                    this._contextMenu.conditionShowOff = this._contextMenu.tempCondition.conditionShow || []
                    // this._contextMenu.listPicked = this._contextMenu.tempCondition?.listPicked
                    this._contextMenu.isLoadFromShow = true
                    this._contextMenu?.contextMenu_ShowOff()
                    this._contextMenu.isLoadFromShow = false

                }
            }

            return; // Nếu đã có, trả về đối tượng đã tồn tại
        }
        // Tạo đối tượng mới (với data có thể là undefined) và thêm vào ObjDataPrimitive
        const newObjData: ObjDataPrimitiveModel = {
            primitive: primitive,
            data: undefined,
            conditionColors: [],
            conditionIsolates: []
        };
        this.ObjDataPrimitive.push(newObjData);
        return newObjData;
    };



    //#region setColorObjs
    setColorObjs = (inputObjs: InputSetColor[]) => {



        // Duyệt qua từng inputObj trong mảng inputObjs
        inputObjs.forEach(inputObj => {
            // Duyệt qua từng objData trong ObjDataPrimitive
            this.ObjDataPrimitive.forEach((objData: ObjDataPrimitiveModel) => {

                // Kiểm tra nếu FileName của inputObj bằng với Folder trong data của objData
                if (objData.data && inputObj.FileName === objData.data.folder) {
                    const conditionColors: [string, string][] = [];
                    let updatedConditions: [string, string][] = [];

                    inputObj.Guids.forEach((guid: string) => {

                        const result = objData.data?.objectConnects?.find((s: FeatureObject) => s && s.guid && String(s.guid).trim() === String(guid).trim());
                        //chỉnh colorBlendMode cho primitive
                        if (result) {
                            objData.primitive.colorBlendMode = 1;
                            const conditionString = `\${batchId}===${result.featureId}&&\${fileName}==='${result.file}'&&\${guid}==='${result.guid}'`;

                            let hex

                            if (typeof inputObj.Color === "string" && inputObj.Color.startsWith('#')) {
                                hex = convertHexWithOpacity(inputObj.Color, inputObj.Opacity!)
                            } else {
                                hex = rgbaToHex(Number(inputObj.Color[0]), Number(inputObj.Color[1]), Number(inputObj.Color[2]), Number(inputObj.Color[3]));
                            }
                            // Kiểm tra nếu điều kiện đã tồn tại
                            const existingIndex = conditionColors.findIndex(
                                (condition) => condition[0] === conditionString
                            );

                            if (existingIndex === -1) {
                                // Thêm mới nếu không tồn tại
                                conditionColors.push([conditionString, `color('${hex}')`]);
                            } else {
                                // Cập nhật màu nếu đã tồn tại
                                conditionColors[existingIndex][1] = `color('${hex}')`;
                            }

                        }
                    });

                    // Nếu có điều kiện, thiết lập style cho primitive
                    if (conditionColors.length > 0) {

                        // Dùng Map để loại bỏ trùng key, ưu tiên giá trị từ conditionColors
                        const mergedColors = new Map(
                            [...(objData.conditionColors || []), ...conditionColors].map(([key, value]) => [key, value])
                        );

                        // Cập nhật objData.conditionColors
                        objData.conditionColors = [...mergedColors];

                        // Tạo Map để tra cứu nhanh các điều kiện từ objData.conditionColors
                        const conditionColorMap = new Map<string, string>();
                        objData.conditionColors.forEach(([conditionKey, conditionValue]: [string, string]) => {
                            conditionColorMap.set(conditionKey, conditionValue);
                        });

                        // console.log("objData.conditionColors", objData.conditionColors);

                        // Duyệt qua objData.conditionColors và cập nhật giá trị từ Map
                        updatedConditions = objData.conditionColors.map((isolateCondition: [string, string]) => {
                            let updatedCondition: [string, string] = [...isolateCondition]; // Tạo bản sao
                            const matchingValue = conditionColorMap.get(isolateCondition[0]);
                            if (matchingValue !== undefined) {
                                updatedCondition[1] = matchingValue; // Cập nhật giá trị nếu tìm thấy
                            }
                            return updatedCondition;
                        });

                        // Sử dụng sort để di chuyển phần tử có "true" về cuối
                        updatedConditions.sort((a, b) => {
                            if (a[0] === "true") return 1; // Đưa a về cuối nếu a là "true"
                            if (b[0] === "true") return -1; // Đưa b về cuối nếu b là "true"
                            return 0; // Giữ nguyên vị trí nếu không có "true"
                        });

                        objData.primitive.style = new Cesium3DTileStyle({
                            defines: {
                                batchId: "${feature['BatchId']}",
                                fileName: "${feature['Filename']}",
                                guid: "${feature['Guid']}"
                            },
                            color: {
                                conditions: updatedConditions.length > 0 ? updatedConditions : objData.conditionColors,
                            },
                        });
                    }



                }
            });
        });
        // console.log("ObjDataPrimitive", this.ObjDataPrimitive);
        this._viewer.scene.requestRender()

    }

    //#region ResetDefaultColor
    // resetDefaultColor = () => {
    //     // Duyệt qua từng objData trong ObjDataPrimitive
    //     this.ObjDataPrimitive.forEach((objData: ObjDataPrimitiveModel) => {

    //         // Nếu có điều kiện, thiết lập style cho primitive
    //         if ((objData.conditionColors ?? []).length > 0) {
    //             objData.primitive.style = new Cesium3DTileStyle({
    //                 defines: {
    //                     batchId: "${feature['BatchId']}",
    //                     fileName: "${feature['Filename']}",
    //                     guid: "${feature['Guid']}"

    //                 },
    //                 color: {
    //                     conditions: objData.conditionColors,
    //                 },
    //             });
    //         }


    //     });

    // }
    resetDefaultColor = () => {
        // Duyệt qua từng objData trong ObjDataPrimitive
        this.ObjDataPrimitive.forEach((objData: ObjDataPrimitiveModel) => {

            // Nếu có điều kiện, thiết lập style cho primitive
            if ((objData.conditionColors ?? []).length > 0) {

                // Sử dụng sort để di chuyển phần tử có "true" về cuối
                objData.conditionColors?.sort((a, b) => {
                    if (a[0] === "true") return 1; // Đưa a về cuối nếu a là "true"
                    if (b[0] === "true") return -1; // Đưa b về cuối nếu b là "true"
                    return 0; // Giữ nguyên vị trí nếu không có "true"
                });
                // console.log("this.ObjDataPrimitive", this.ObjDataPrimitive);

                objData.primitive.style = new Cesium3DTileStyle({
                    defines: {
                        batchId: "${feature['BatchId']}",
                        fileName: "${feature['Filename']}",
                        guid: "${feature['Guid']}"

                    },
                    color: {
                        conditions: objData.conditionColors,
                    },
                });
            }


        });


        this._viewer.scene.requestRender()

    }

    //#region ResetAllDefaultColor
    resetAllDefaultColor = () => {
        this.ObjDataPrimitive.forEach((objData: any) => {
            // objData.primitive.colorBlendMode = 0
            objData.primitive.style = null

        })
        this.resetDefaultIsolate()
        this.ObjDataPrimitive = []
        this._viewer.scene.requestRender()

    }
    //#region ResetAllColor
    resetAllColor = () => {
        this.ObjDataPrimitive.forEach((objData: any) => {
            // objData.primitive.colorBlendMode = 0
            objData.primitive.style = null
            objData.conditionColors = []
        })

        // ObjDataPrimitive = []
        this._viewer.scene.requestRender()

    }

    //#region SetColorByTask
    setColorByTask = async (completeObj: TaskColorByObj, inProgressObj: TaskColorByObj, reColor: [number, number, number, number] | string = [240, 240, 240, 1]) => {


        this.ObjDataPrimitive.forEach((objData: ObjDataPrimitiveModel) => {

            objData.conditionColors?.push(["true", `color("rgba(${reColor[0]},${reColor[1]},${reColor[2]},${reColor[3]})")`])
            objData.primitive.colorBlendMode = 1
            objData.primitive.style = new Cesium3DTileStyle({
                defines: {
                    batchId: "${feature['BatchId']}",
                    fileName: "${feature['Filename']}",
                    guid: "${feature['Guid']}"
                },
                color: {
                    conditions: objData.conditionColors
                },
            });

        })
        this._viewer.scene.requestRender()

        const combinedList: InputSetColor[] = [];

        const mergeTaskColor = (taskObj: TaskColorByObj) => {
            taskObj.objTask.forEach((task: InputObjTask) => {
                // Tìm đối tượng đã tồn tại với cùng FileName và Color
                const existingItem = combinedList.find(
                    (item) => item.FileName === task.fileName && item.Color === taskObj.color
                );

                if (existingItem) {
                    // Gộp GUIDs nếu tồn tại
                    existingItem.Guids = [...new Set([...existingItem.Guids, ...task.guids])];
                } else {
                    // Thêm mới nếu chưa có
                    combinedList.push({
                        FileName: task.fileName,
                        Guids: task.guids,
                        Color: taskObj.color,
                        Opacity: Array.isArray(taskObj.color) ? taskObj.color[3] : 1,
                    });
                }
            });
        };

        // Gộp hai danh sách complete và in-progress
        mergeTaskColor(completeObj);
        mergeTaskColor(inProgressObj);

        this.setColorObjs(combinedList)


    }



    //#region Isolate
    isolateObjs = (inputObjs: InputIsolate[]) => {
        const primitives = this._viewer.scene.primitives

        // Duyệt qua từng inputObj trong mảng inputObjs
        inputObjs?.forEach((inputObj: InputIsolate) => {
            // Duyệt qua từng objData trong ObjDataPrimitive
            this.ObjDataPrimitive.forEach((objData: ObjDataPrimitiveModel) => {
                let primitive
                for (let i = 0; i < primitives.length; ++i) {
                    const pri = primitives.get(i);
                    if (pri.resource && pri.resource.url && pri.resource.url === objData.primitive.resource.url) {
                        primitive = pri;
                        break;
                    }
                }
                if (primitive) {
                    // Kiểm tra nếu FileName của inputObj bằng với Folder trong data của objData
                    if (objData.data && inputObj.FileName === objData.data.folder) {
                        const conditionsIsolate: [string, string][] = [];
                        let updatedConditions: [string, string][] = [];


                        inputObj.Guids.forEach((guid: string) => {
                            const result = objData.data?.objectConnects?.find((s: FeatureObject) => s.guid === guid);
                            if (result) {
                                const conditionString = `\${batchId}===${result.featureId}&&\${fileName}==='${result.file}'&&\${guid}==='${result.guid}'`;
                                if (!conditionsIsolate.some((condition) => condition[0] === conditionString)) {
                                    const newConditionIsolate: [string, string] = [conditionString, 'color("rgba(255,255,255,1)")'];

                                    const conditionColor = objData.conditionColors?.find((condition) => condition[0] === 'true');
                                    if (conditionColor) {
                                        newConditionIsolate[1] = conditionColor[1];
                                    }

                                    conditionsIsolate.push(newConditionIsolate);
                                }


                            }
                        });
                        // Nếu có điều kiện, thiết lập style cho primitive
                        if (conditionsIsolate.length > 0) {
                            // Gán `updatedConditions` bằng `conditionsIsolate` ngay từ đầu
                            updatedConditions = [...conditionsIsolate];
                            if ((objData.conditionColors ?? []).length > 0) {
                                updatedConditions = updatedConditions.map((isolateCondition: [string, string]) => {
                                    let updatedCondition: [string, string] = [...isolateCondition];

                                    objData.conditionColors?.forEach((conditionColor: [string, string]) => {
                                        // Nếu điều kiện trùng, cập nhật màu sắc
                                        if (isolateCondition[0] === conditionColor[0]) {
                                            updatedCondition[1] = conditionColor[1];
                                        }
                                    });

                                    return updatedCondition;
                                });
                            }
                            if (!objData.conditionIsolates) {
                                objData.conditionIsolates = []; // Đảm bảo không bị undefined
                            }
                            // Thêm từng điều kiện vào mảng conditionsColor trong objData                    
                            objData.conditionIsolates = [...objData.conditionIsolates, ...updatedConditions];

                            //Kiểm tra đã có điều kiện chưa isolate chưa có rồi thì xóa đi
                            objData.conditionIsolates = objData.conditionIsolates.filter(
                                (condition: [string, string]) => !(condition[0] === "true" && condition[1] === 'color("rgba(204,203,209,0.02)")')
                            );

                            if (this._contextMenu) {
                                this._contextMenu.conditionForShowOff = [...objData.conditionIsolates];
                            }

                        }

                    }

                    if ((!objData.conditionIsolates || objData.conditionIsolates.length === 0) || objData.conditionIsolates[objData.conditionIsolates.length - 1][0] !== "true") {

                        //Add vào cuối cùng
                        objData.conditionIsolates?.push(['true', 'color("rgba(204,203,209,0.02)")'])
                    }

                    primitive.style = null;

                    primitive.style = new Cesium3DTileStyle({
                        defines: {
                            batchId: "${feature['BatchId']}",
                            fileName: "${feature['Filename']}",
                            guid: "${feature['Guid']}"
                        },
                        color: {
                            conditions: objData.conditionIsolates,
                        },
                    });
                }
            });
        });
        this._viewer.scene.requestRender()
        // const primitives = this._viewer.scene.primitives;
        // console.log("primitives", primitives);

    }

    //#region ResetDefaultIsolate
    resetDefaultIsolate = () => {

        // Duyệt qua từng objData trong ObjDataPrimitive
        this.ObjDataPrimitive.forEach((objData: any) => {

            // Nếu có điều kiện, thiết lập style cho primitive
            if (objData.conditionColors.length > 0) {
                objData.primitive.style = null
                objData.primitive.colorBlendMode = 1
                const updatedConditions = objData.conditionIsolates.map((isolateCondition: any) => {
                    let updatedCondition = [...isolateCondition]; // Tạo bản sao của isolateCondition để không thay đổi dữ liệu gốc
                    objData.conditionColors.forEach((conditionColor: [string, string]) => {
                        // Kiểm tra nếu giá trị đầu của isolateCondition trùng với giá trị đầu của conditionColor
                        if (isolateCondition[0] === conditionColor[0]) {
                            // Cập nhật giá trị thứ hai của updatedCondition
                            updatedCondition[1] = conditionColor[1];
                        }
                    })
                    return updatedCondition
                })
                objData.primitive.style = new Cesium3DTileStyle({
                    defines: {
                        batchId: "${feature['BatchId']}",
                        fileName: "${feature['Filename']}",
                        guid: "${feature['Guid']}"

                    },
                    color: {
                        conditions: updatedConditions,
                    },
                });
            }


        });
        this._viewer.scene.requestRender()

    }


    //#region Reset All Default Isolate
    resetAllDefaultIsolate = () => {
        this.ObjDataPrimitive.forEach((objData: any) => {
            objData.primitive.style = null
            // objData.primitive.colorBlendMode = 0

        })
        this.resetDefaultColor()

        this.ObjDataPrimitive = []
        this._viewer.scene.requestRender()

    }

    //#region ResetAllIsolate
    resetAllIsolate = () => {
        this.ObjDataPrimitive.forEach((objData: ObjDataPrimitiveModel) => {
            objData.primitive.style = null
            // objData.primitive.colorBlendMode = 0
            objData.conditionIsolates = []
        })


        // ObjDataPrimitive = []
        this._viewer.scene.requestRender()

    }
    clearObjDataPrimitive = () => {
        this.ObjDataPrimitive = []
        this._viewer.scene.requestRender()

    }



}


//#region Zoom Min Max
export const zoomMinMax = async (viewer: any, inputObjs: any[], ObjDataPrimitive: ObjDataPrimitiveModel[]) => {
    // console.log("ZOOM", ObjDataPrimitive);
    let allowZoom = false;
    let xMax = Number.MIN_VALUE;
    let yMax = Number.MIN_VALUE;
    let zMax = Number.MIN_VALUE;
    let xMin = Number.MAX_VALUE;
    let yMin = Number.MAX_VALUE;
    let zMin = Number.MAX_VALUE;

    for (const inputObj of inputObjs) {
        ObjDataPrimitive.forEach((objData: ObjDataPrimitiveModel) => {
            if (objData.data?.folder === inputObj.FileName) {
                const compare = comparePoints(objData.data?.originalBoundingBox, objData.primitive.boundingSphere?.center) ? true : false
                for (const guid of inputObj.Guids) {
                    const result = objData.data?.objectConnects!.find((s: FeatureObject) => s.guid === guid);
                    if (result && result.maxPoint && result.minPoint) {
                        allowZoom = true;
                        if (!compare) {
                            try {
                                const newBoundingBoxCenter = objData.primitive.boundingSphere?.center;

                                const newMaxPoint = movePointToNewBoudingBox(
                                    objData.data?.originalBoundingBox,
                                    newBoundingBoxCenter,
                                    [result.maxPoint[1], result.maxPoint[0], result.maxPoint[2]]
                                )
                                const newMinPoint = movePointToNewBoudingBox(
                                    objData.data?.originalBoundingBox,
                                    newBoundingBoxCenter,
                                    [result.minPoint[1], result.minPoint[0], result.minPoint[2]]
                                )
                                xMax = Math.max(xMax, newMaxPoint[0]);
                                yMax = Math.max(yMax, newMaxPoint[1]);
                                zMax = Math.max(zMax, newMaxPoint[2]);
                                xMin = Math.min(xMin, newMinPoint[0]);
                                yMin = Math.min(yMin, newMinPoint[1]);
                                zMin = Math.min(zMin, newMinPoint[2]);
                            } catch (error) {
                                return
                            }


                        } else {
                            xMax = Math.max(xMax, result.maxPoint[1]);
                            yMax = Math.max(yMax, result.maxPoint[0]);
                            zMax = Math.max(zMax, result.maxPoint[2]);
                            xMin = Math.min(xMin, result.minPoint[1]);
                            yMin = Math.min(yMin, result.minPoint[0]);
                            zMin = Math.min(zMin, result.minPoint[2]);
                        }
                    }
                }
            }
        })

    }

    if (allowZoom) {
        const max = Cartesian3.fromDegrees(xMax, yMax, zMax);
        const min = Cartesian3.fromDegrees(xMin, yMin, zMin);

        const distance = Cartesian3.distance(min, max) / 2;

        const center = new Cartesian3(
            (min.x + max.x) / 2,
            (min.y + max.y) / 2,
            (min.z + max.z) / 2
        );
        const combinedBoundingSphere = new BoundingSphere(center, distance);

        viewer.camera.flyToBoundingSphere(combinedBoundingSphere, { duration: 1 });
    }
};
const comparePoints = (point1: any, point2: any) => {
    const epsilon = 1e-6; // Ngưỡng sai số
    return Math.abs(point1.x - point2.x) < epsilon &&
        Math.abs(point1.y - point2.y) < epsilon &&
        Math.abs(point1.z - point2.z) < epsilon;
}

const movePointToNewBoudingBox = (
    currentBoundingBoxCenter: any, // Center của Bounding Box cũ (ECEF)
    newBoundingBoxCenter: any, // Center của Bounding Box mới (ECEF)
    pointLatLongHeight: number[] // Tọa độ của điểm (latitude, longitude, altitude)
) => {
    // Bước 1: Chuyển điểm từ latitude, longitude, altitude sang hệ tọa độ ECEF (Cartesian)
    const pointInOldBoundingBox = Cartesian3.fromDegrees(pointLatLongHeight[0], pointLatLongHeight[1], pointLatLongHeight[2]);
    // Bước 2: Tính toán vector dịch chuyển (translation vector) giữa hai center
    const translationVector = {
        x: newBoundingBoxCenter.x - currentBoundingBoxCenter.x,
        y: newBoundingBoxCenter.y - currentBoundingBoxCenter.y,
        z: newBoundingBoxCenter.z - currentBoundingBoxCenter.z
    };
    // Bước 3: Dịch chuyển điểm cũ sang vị trí mới (áp dụng vector dịch chuyển)
    const movedPoint = {
        x: pointInOldBoundingBox.x + translationVector.x,
        y: pointInOldBoundingBox.y + translationVector.y,
        z: pointInOldBoundingBox.z + translationVector.z
    };
    // Bước 4: Chuyển đổi lại tọa độ mới từ hệ tọa độ ECEF (Cartesian) về hệ tọa độ địa lý (longitude, latitude, altitude)
    const cartesianPoint = new Cartesian3(movedPoint.x, movedPoint.y, movedPoint.z);
    const cartographic = Cartographic.fromCartesian(cartesianPoint);
    const newLatLongHeight = [
        MathCesium.toDegrees(cartographic.longitude),
        MathCesium.toDegrees(cartographic.latitude),
        cartographic.height
    ];

    // Trả về tọa độ mới
    return newLatLongHeight;
}
